module.exports = __webpack_public_path__ + "img/wuli.e3b1036e.png";